'use strict';

if ((window.location.pathname.includes('returnpayment') || window.location.pathname.includes('Return-Payment')) && window.isAdyenReturnPayment) {
    var checkout;

    async function handleAction(action) {
        window.Configuration.onAdditionalDetails = onAdditionalDetails;
        checkout = await AdyenCheckout(window.Configuration);
        const actionContainer = document.getElementById('action-container');
        checkout.createFromAction(action).mount(actionContainer);
    }

    // onAdditionalDetails event handler to be included in Adyen Component configuration
    var onAdditionalDetails = function (state) {
      $.ajax({
        type: 'POST',
        url: window.returnPaymentsDetails,
        data: JSON.stringify({
          data: state.data,
          orderToken: window.orderToken,
        }),
        contentType: 'application/json; charset=utf-8',
        async: false,
        success: function (data) {
          if (data.response.isSuccessful) {
            window.location.href = data.response.redirectUrl;  
          } else if (!data.response.isFinal && typeof data.response.action === 'object') {
            handleAction(data.action);
          } else {
            window.location.href = window.returnPaymentError;
          }
        },
      });
    }

    var orderBeingPlaced = false;

    // serializes form data and submits to place order. Then proceeds to handle the result
    function placeOrder() {
        if (orderBeingPlaced) {
            return;
        }
        orderBeingPlaced = true;

        const $form = $('#dwfrm_return');
        var url = $form.attr('action');
        var paymentStartURL = $form.attr('data-returnpayment');
        var applyName = $form.find('#return-submit').attr('name');
        $.ajax({
            method:'POST',
            url: url,
            data: $form.serialize() + '&' + applyName + '=x',
            async: false,
            success: function(data) {
              if (data.action) {
                document.getElementById('action-modal-SG').style.display = "block";
                handleAction(data.action);
              } else if (data.redirectUrl) {
                console.log('Redirecting to: ' + data.redirectUrl);
                window.location.href = data.redirectUrl;
              } else {
                console.log('No redirect URL, going to payment start: ' + paymentStartURL);
                window.location.href = paymentStartURL;
              }
            },
            error: function(err) {
              console.error(err);
              orderBeingPlaced = false;
              window.location.href = paymentStartURL;
            }
        });
    }

    module.exports.placeOrder = placeOrder;
}